<template>
  <div class="container">
    <div class="privacy-content">
      <div class="header-banner">
        <button class="back-button" @click="goBack">
          <svg class="back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="avatar-section">
        <img src="@/assets/images/avatar.png" class="avatar">
        <span class="username">{{userInfo.username}}</span>
      </div>
      
      <div class="info-card" v-if="hasBank1">
        <div class="section-title">{{decryptLabel(title1)}}</div>
        <div class="info-item-group">
          <div v-for="(item, idx) in loanItems" :key="idx">
            <div class="info-item">
              <span class="info-label">{{decryptLabel(item.label)}}</span>
              <span class="info-value">{{item.value}}</span>
            </div>
            <div class="divider-line" v-if="idx < loanItems.length - 1"></div>
          </div>
        </div>
      </div>
      
      <div class="info-card" v-if="hasBank2">
        <div class="section-title">{{decryptLabel(title2)}}</div>
        <div class="qrcode-card">
          <img :src="qrcode" class="qrcode-image" />
          <span class="qrcode-tip">请扫描上方二维码完成支付</span>
        </div>
      </div>
      
    </div>
    <button class="back-btn" @click="handleButtonTap('kefu')">联系在线客服</button>
  </div>
</template>

<script>
import { baseUrl } from '@/utils/util'
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      loanItems: [
        { label: "s8faAtHNpBt+jsMfqWPF4A==", value: "" },
        { label: "oyZEO2v/Jzvas0CvRDkPuQ==", value: "" },
        { label: "Lnh9i2RCfPCcQSJ7ijigOA==", value: ""}
      ],
      userInfo: {},
      qrcode: "",
      hasBank1: false,
      hasBank2: false,
      title1: "LnFDWPHcPmqq1QPhoKPwww==",
      title2: "5B58HHiVVAHg8gFxyRKteA=="
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    goBack() {
      this.$router.go(-1);
    },
    async getUserInfo() {
      try {
        this.userInfo = this.$store.state.user.userInfo || {};
        const response = await this.$store.dispatch('user/getLoan');
        
        if (response && Array.isArray(response)) {
          const addresses = response;
          
          addresses.forEach((item, index) => {
            if (item.type === "0") {
              this.loanItems[0].value = item.holderName || '';
              this.loanItems[1].value = item.bankName || '';
              this.loanItems[2].value = item.cardNo || '';
              if (item.bankTitle) {
                this.title1 = item.bankTitle;
              }
              this.hasBank1 = true;
            }
            
            if (item.type === "1") {
              if (item.cardNo) {
                const qrcodePath = item.cardNo;
                if (qrcodePath.startsWith('http://') || qrcodePath.startsWith('https://')) {
                  this.qrcode = qrcodePath;
                } else {
                  this.qrcode = baseUrl + '/' + qrcodePath.replace(/^\//, '');
                }
              }
              if (item.bankTitle) {
                this.title2 = item.bankTitle;
              }
              this.hasBank2 = true;
            }
          });
          
          this.$forceUpdate();
        }
      } catch (error) {
      }
    },
    handleButtonTap(action) {
      this.$router.push(`/${action}`);
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.privacy-content {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.header-banner {
  height: 150px;
  background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
  border-radius: 0 0 20px 20px;
  padding: 16px;
  position: relative;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #fff;
  backdrop-filter: blur(4px);
}

.back-button:active {
  transform: scale(0.94);
  background: rgba(255, 255, 255, 0.35);
}

.back-icon {
  width: 20px;
  height: 20px;
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -75px;
  z-index: 2;
  position: relative;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}

.username {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-top: 12px;
}

.info-card {
  background-color: #fff;
  border-radius: 12px;
  margin: 24px 0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}

.section-title {
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #1e80ff;
  border-bottom: 1px solid #f2f4f6;
}

.info-item-group {
  padding: 0 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
}

.divider-line {
  height: 1px;
  background-color: #f2f4f6;
  margin: 0 8px;
}

.info-label {
  font-size: 16px;
  color: #666;
  flex-basis: 30%;
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: right;
  flex: 1;
}

.qrcode-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
}

.qrcode-tip {
  font-size: 14px;
  color: #999;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 128, 255, 0.3);
}
</style>
